/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */
import { reduce } from './reduce';
function toArrayReducer(arr, item, index) {
    if (index === 0) {
        return [item];
    }
    arr.push(item);
    return arr;
}
export function toArray() {
    return reduce(toArrayReducer, []);
}
//# sourceMappingURL=toArray.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/operators/toArray.js
// module id = 763
// module chunks = 1